<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '系统提示',
    },
  },
  data() {
    return {
      mVisible: this.value,
    };
  },
  watch: {
    mVisible(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.mVisible = val;
    },
  },
};
</script>
